module.exports = __webpack_public_path__ + "img/36.d8ad3f17.jpg";